import {Subscription} from 'rxjs';

import IPlayer from '../Player/Interfaces/IPlayer';

import connectCaptionsSubscriptions     from './Stores/Captions/connectCaptionsSubscriptions';
import connectConfigSubscriptions       from './Stores/Config/connectConfigSubscriptions';
import connectFrameSubscriptions        from './Stores/Frame/connectFrameSubscriptions';
import connectLocalStorageSubscriptions from './Stores/LocalStorage/connectLocalStorageSubscriptions';
import connectMediaSubscriptions        from './Stores/Media/connectMediaSubscriptions';
import connectPlaybackSubscriptions     from './Stores/Playback/connectPlaybackSubscriptions';
import connectTimelineSubscriptions     from './Stores/Timeline/connectTimelineSubscriptions';
import connectVolumeSubscriptions       from './Stores/Volume/connectVolumeSubscriptions';

/**
 * Connects all stores to their respective input streams, returning a
 * list of `Subscription` instances to be unsubscribed from at a later time.
 */

const connectStoreSubscriptions = (player: IPlayer): Subscription[] => ([
    ...connectCaptionsSubscriptions(player),
    ...connectConfigSubscriptions(player),
    ...connectFrameSubscriptions(player),
    ...connectLocalStorageSubscriptions(player),
    ...connectMediaSubscriptions(player),
    ...connectPlaybackSubscriptions(player),
    ...connectTimelineSubscriptions(player),
    ...connectVolumeSubscriptions(player)
]);

export default connectStoreSubscriptions;